import React, { PureComponent } from "react";
import ReactMarkdown from 'react-markdown';
import CodeBlock from "./CodeBlock";
import _ from "lodash";
import ReactAudioPlayer from 'react-audio-player';
import Link from "./Link";
import IframeVideo, { getEmbedURL } from "./IframeVideo";

const imgRegex = /^.*\.(png|jpg|jpeg|gif|svg|gif|bmp|tiff|webp)$/;
const audioRegex = /^.*\.(mp3|wav|m4a)$/;
const urlRegex = /^http:/;
const escapeStringRegex = new RegExp("\\\\", "g");


class CodeMarkdown extends React.Component {
    static defaultProps = {
        editorProps: {}
    };

    shouldComponentUpdate = (nextProps) => {
        return !_.isEqual(this.props, nextProps);
    };

    render() {
        let { codeEditorProps, source = "", ...markdownProps} = this.props;
        const renderCodeBlock = (codeBlockProps) => <CodeBlock {...codeEditorProps} {...codeBlockProps} />
        const renderMediaElement = ({src, alt}) => {
            if(!urlRegex.test(src) && this.props.question) {
                const attachments = this.props.question.attachments || [];

                for(let i = 0; i < attachments.length; i++) {
                    let attachment = attachments[i];

                    if(i == src || src === attachment.id || src === attachment.filename) {
                        try {
                            const url = new URL(attachment.url);
                            src = url.href.replace(url.search, "");
                        } catch {}
                        break;
                    }
                }
            }

            if(!src || !src.length) { return; }

            if(imgRegex.test(src)) {
                return <img alt={alt} src={src} style={{maxWidth: '100%', marginTop: '15px', marginBottom: '15px'}} />
            }

            if(audioRegex.test(src)) {
                return <ReactAudioPlayer alt={alt} src={src} style={{width: '100%', marginTop: '15px', marginBottom: '15px'}} controls />
            }

            if(getEmbedURL(src)) {
                return <IframeVideo src={src} />
            }

            return null;
        };

        return <ReactMarkdown
            {...markdownProps}
            source={source.replace(escapeStringRegex, "")}

            renderers={{
                codeBlock: renderCodeBlock,
                code: renderCodeBlock,
                image: renderMediaElement,
                link: Link,
            }}
        />;
    }
}

export default CodeMarkdown;